<div class="card">
	<div class="card-header">
		<h1>Partners No Asociados <!-- <i (click)="showModalCreate = true" tooltip="Agregar Empresa Asociada"
				class="clickeable fa fa-circle-plus text-info"></i> --></h1>
	</div>
	<div class="card-body">
		<span class="text-muted"><i class="fa fa-circle-info"></i>Para asociar una empresa a un partner, conecta los
			circulos <i class="fa-regular fa-circle"></i>, luego presiona guardar</span>
		<div class="row">
			<svg id="svg-container" #svgContainer></svg>
			<div class="col">
				<div class="form-group">
					<label for="searchAssociatePartner" class="form-label">Buscar partner </label>
					<input type="text" placeholder="Ingresa nombre del partner" (input)="writePartner()"
						[(ngModel)]="filterPartners" id="searchAssociatePartner" name="searchAssociatePartner"
						class="form-control">
				</div>
				<div class="table-responsive mt-3" [class.table-responsive-without]="queueDelete">
					<table class="table table-bordered" id="table-partners" name="table-partners"
						style="margin-bottom: 0;">
						<thead>
							<tr class="tr-middle">
								<th></th>
								<th>Email</th>
								<th>Nombre</th>
								<th></th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngFor="let associate of partners">
								<tr [class.hide-all]="queueDelete?.id==associate.id" class="item tr-middle"
									(click)="selectRow('table-partners', associate.id)"
									[class.selected]="associate.id == partnerId">
									<td>
										<span class="icon clickeable" (click)="getCompaniesAssociated(associate)">
											<span class="superposition-container">
												<i class="fas fa-building"></i>
												<i [ngClass]="associate.showCompany?'fa-eye-slash':'fa-eye'"
													class="fa-solid superposition-element"></i>
											</span>
										</span>
									</td>
									<td>{{associate.email}}</td>
									<td>{{associate.name}}</td>
									<!-- <td>
										<div style="display: flex; justify-content: space-evenly;">
											<div class="container-superposition" title="Eliminar">
												<div class="element-superposition" *ngIf="queueDelete?.id == associate.id">
													<span>¿Está seguro que desea eliminar esta empresa?</span>
													<span class="a-container">
														<span class="clickeable text-info" (click)="queueDelete = null"><i
																class="fa fa-ban"></i>NO</span>
														<span class="clickeable text-danger"><i class="fa fa-trash"
																(click)="confirmDelete(associate)"></i>SÍ</span>
													</span>
												</div>
												<span class="clickeable text-danger" (click)="deleteAssociate(associate)">
													<i *ngIf="!deleting[associate.id]" class="fa fa-trash"></i>
													<span *ngIf="deleting[associate.id]"
														class="spinner-border spinner-border-sm" aria-hidden="true"></span>
												</span>
											</div>
										</div>
									</td> -->
									<td>
										<i
											[ngClass]="associate.id == partnerId?'fa-solid fa-circle':'fa-regular fa-circle'"></i>
									</td>
								</tr>
								<tr *ngIf="associate.showCompany">
									<td colspan="4">
										<table class="table table-bordered">
											<thead>
												<tr>
													<th>NIT</th>
													<th>Nombre</th>
													<th></th>
												</tr>
											</thead>
											<tbody>
												<tr *ngFor="let c of associate.companies">
													<td>{{c.nit}}</td>
													<td>{{c.name}}</td>
													<td>
														<i *ngIf="!deleting[c.id]" (click)="deleteAssociate(c)"
															class="fa fa-trash text-danger clickeable"></i>
														<span *ngIf="deleting[c.id]" class="spinner-border spinner-border-sm"
															aria-hidden="true"></span>
													</td>
												</tr>
												<tr *ngIf="associate.companies.length==0 && associate.loading">
													<td style="padding: 2em;" colspan="3">
														<div class="d-flex align-items-center">
															<strong role="status">Cargando...</strong>
															<div class="spinner-border ms-auto" aria-hidden="true">
															</div>
														</div>
													</td>
												</tr>
												<tr class="tr-middle"
													*ngIf="associate.companies.length==0 && !associate.loading">
													<td colspan="3">
														<span class="text-muted">
															<i class="fa fa-circle-info"></i>
															No tiene empresas asociadas.
														</span>
													</td>
												</tr>
											</tbody>
										</table>
									</td>
								</tr>
							</ng-container>
							<tr class="tr-middle" *ngIf="partners.length == 0">
								<td colspan="4" class="text-muted">
									<i class="fa fa-circle-info"></i> {{failedStart?
									'No se pudieron obtener las empresas asociadas, fallo en el servidor'
									:'No se encontraron resultados'}}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<app-simple-pagination id="partners-pag" (changed)="partnerId = null; getPartners()" [sizes]="[5]"
					[elements]="paginationPartners"></app-simple-pagination>
			</div>
			<div class="col">
				<div class="form-group">
					<label for="searchCompany" class="form-label">Buscar empresa no asociada </label>
					<input type="text" placeholder="Ingresa nombre de empresa no asociada" (input)="writeCompany()"
						[(ngModel)]="filterCompanies" id="searchCompany" name="searchCompany" class="form-control">
				</div>
				<div class="table-responsive mt-3" [class.table-responsive-without]="queueDelete">
					<table class="table table-bordered" id="table-no-associated" name="table-no-associated"
						style="margin-bottom: 0;">
						<thead>
							<tr class="tr-middle">
								<th></th>
								<th>NIT</th>
								<th>Nombre</th>
							</tr>
						</thead>
						<tbody>
							<tr [class.hide-all]="queueDelete?.id==associate.id" class="item tr-middle"
								*ngFor="let associate of companies"
								(click)="selectRow('table-no-associated', associate.id)"
								[class.selected]="associate.id == companyId">
								<td>
									<i
										[ngClass]="associate.id == companyId?'fa-solid fa-circle':'fa-regular fa-circle'"></i>
								</td>
								<td>{{associate.nit}}</td>
								<td>{{associate.name}}</td>
								<!-- <td>
			
									<div style="display: flex; justify-content: space-evenly;">
										<div class="container-superposition" title="Eliminar">
											<div class="element-superposition" *ngIf="queueDelete?.id == associate.id">
												<span>¿Está seguro que desea eliminar esta empresa?</span>
												<span class="a-container">
													<span class="clickeable text-info" (click)="queueDelete = null"><i
															class="fa fa-ban"></i>NO</span>
													<span class="clickeable text-danger"><i class="fa fa-trash"
															(click)="confirmDelete(associate)"></i>SÍ</span>
												</span>
											</div>
											<span class="clickeable text-danger" (click)="deleteAssociate(associate)">
												<i *ngIf="!deleting[associate.id]" class="fa fa-trash"></i>
												<span *ngIf="deleting[associate.id]"
													class="spinner-border spinner-border-sm" aria-hidden="true"></span>
											</span>
										</div>
									</div>
								</td> -->
							</tr>
							<tr class="tr-middle" *ngIf="companies.length == 0">
								<td colspan="4" class="text-muted">
									<i class="fa fa-circle-info"></i> {{failedStart?
									'No se pudieron obtener las empresas asociadas, fallo en el servidor'
									:'No se encontraron resultados'}}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<app-simple-pagination id="companies-pag" [sizes]="[5]"
					(changed)="companyId = null; getCompaniesNoAssociated()"
					[elements]="paginationCompanies"></app-simple-pagination>
			</div>
		</div>
		<div style="margin-top: 1em; width: 100%; display: flex; justify-content: center;">
			<app-loading-button [disabled]="!partnerId || !companyId" [object]="buttonAssociate"
				(clicked)="associateToPartner()"></app-loading-button>
		</div>
	</div>
</div>
<div class="hide-background" *ngIf="queueDelete">
	<div class="for-click" (click)="queueDelete = null"></div>
</div>
<app-modal-associate-company *ngIf="showModalCreate" (close)="closeModalCreate($event)"></app-modal-associate-company>